import ofertaCajaAhorro, {
  premios,
  beneficios,
  oferta,
  proximosPasos
} from "@/config/brands/ofertaCajaAhorro";

describe("ofertaCajaAhorro config", () => {
  test("configuracion exportada por defecto", () => {
    expect(ofertaCajaAhorro).toHaveProperty("googleAnalyticsId");
    expect(ofertaCajaAhorro).toHaveProperty("googleGTMId");
    expect(ofertaCajaAhorro).toHaveProperty(
      "modulo",
      "Cuenta y Tarjeta de Débito"
    );
    expect(ofertaCajaAhorro).toHaveProperty("cantPasos", 9);
  });

  describe("Premios", () => {
    test("Premios array should have specific structure", () => {
      premios.forEach(premio => {
        expect(premio).toHaveProperty("label");
        expect(premio).toHaveProperty("icon");
      });
    });
  });

  describe("Beneficios", () => {
    test("Beneficios array should have specific structure", () => {
      beneficios.forEach(beneficio => {
        expect(beneficio).toHaveProperty("label");
        expect(beneficio).toHaveProperty("description");
      });
    });
  });

  describe("Oferta", () => {
    test("Oferta array should have specific structure", () => {
      oferta.forEach(ofertaItem => {
        expect(ofertaItem).toBeDefined();
      });
    });
  });

  describe("Proximos Pasos", () => {
    test("Proximos Pasos array should have specific structure", () => {
      proximosPasos.forEach(paso => {
        expect(paso).toHaveProperty("label");
      });
    });
  });
});
